const sessionVariables = {
  USER: 'user',
  GLOBALS: 'globals',
}

/** @param {SessionUser} user */
export function setSessionData(user) {
  setSessionUser(user)
}

/**
 * @param {SessionUser} user a logged in user
 * @returns
 */
export function setSessionUser(user) {
  return window.localStorage.setItem(
    sessionVariables.USER,
    JSON.stringify(user)
  )
}

/** @returns {SessionUser | null} */
export function getSessionUser() {
  const stored = window.localStorage.getItem(sessionVariables.USER)
  return stored && JSON.parse(stored)
}

/**
 * Checks if user data exists in storage (for JWT validation flow)
 * @returns {boolean}
 */
export function hasSessionUser() {
  return !!window.localStorage.getItem(sessionVariables.USER)
}

export function clearSession() {
  window.localStorage.removeItem(sessionVariables.USER)
  window.sessionStorage.clear()
}

export function deleteSessionUser() {
  window.localStorage.removeItem(sessionVariables.USER)
}

/**
 * Refreshes user data from API when JWT is valid but user data is missing
 * Call this when JWT validation passes but getSessionUser() returns null
 * @param {Function} fetchUserDataCallback - Function that fetches and returns user data
 */
export async function refreshSessionUser(fetchUserDataCallback) {
  try {
    const userData = await fetchUserDataCallback()
    if (userData) {
      setSessionUser(userData)
      return userData
    }
    return null
  } catch (error) {
    console.error('Failed to refresh user session data:', error)
    return null
  }
}

/** @param {SessionAccountSettings} settings */
export function storeSessionGlobals(settings) {
  // Keep globals in sessionStorage (less sensitive, session-based)
  window.sessionStorage.setItem(
    sessionVariables.GLOBALS,
    JSON.stringify(settings)
  )
}

/**
 * @returns {SessionAccountSettings}
 */
export function getSessionGlobals() {
  const stored = window.sessionStorage.getItem(sessionVariables.GLOBALS)
  return stored && JSON.parse(stored)
}
